import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import UsersService from "@services/UsersService";

export const createUser = createAsyncThunk(
  "user/create",
  async ({user}, {rejectWithValue}) => {
    try {
      await UsersService.createUser({user});
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const current = {
  name: "",
  lastname: "",
  email: "",
  password: "",
  role: "",
  product_line_id: "",
  country: "",
  region: "",
  cover: null,
};

const initialState = {
  target: current,
  isChanged: false,
  errors: null,
  error: "",
  status: "",
};

const createUserSlice = createSlice({
  name: "create-user",
  initialState,
  reducers: {
    setTarget(state, action) {
      state.target = action.payload;
    },
    setIsChanged(state, action) {
      state.isChanged = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearCreate() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createUser.pending, (state) => {
        pendingState(state);
      })
      .addCase(createUser.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(createUser.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {setIsChanged, setTarget, setError, setStatus, clearCreate} =
  createUserSlice.actions;
export default createUserSlice.reducer;
